var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeyImageCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.353,
    height: 104.177,
    viewBox: "0 0 90.353 104.177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ley",
    transform: "translate(2.353 1.681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11004",
    "data-name": "Group 11004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24033",
    "data-name": "Path 24033",
    d: "M152.238,192.03h-7.751v-7.751a1.364,1.364,0,0,0-1.364-1.364H139.64a1.364,1.364,0,0,0-1.364,1.364v7.751h-7.751a1.364,1.364,0,0,0-1.364,1.364v3.483a1.364,1.364,0,0,0,1.364,1.364h7.751v7.751a1.363,1.363,0,0,0,1.364,1.363h3.483a1.363,1.363,0,0,0,1.364-1.363V198.24h7.751a1.364,1.364,0,0,0,1.364-1.364v-3.483a1.364,1.364,0,0,0-1.364-1.364",
    transform: "translate(-131.514 -184.596)",
    fill: "#de5e60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24031",
    "data-name": "Path 24031",
    d: "M83.152,106.571H32.493a7.51,7.51,0,0,1-7.51-7.51V33.614a7.51,7.51,0,0,1,7.51-7.51H67.852l22.809,22.81V99.061a7.51,7.51,0,0,1-7.51,7.51",
    transform: "translate(-14.116 -14.75)",
    fill: "#c0e4d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24032",
    "data-name": "Path 24032",
    d: "M123.311,26.1l-.178,16.718a6.028,6.028,0,0,0,6.027,6.092H146.12Z",
    transform: "translate(-69.575 -14.75)",
    fill: "#a7c7be"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9396",
    "data-name": "Rectangle 9396",
    width: 19.573,
    height: 3.915,
    transform: "translate(24.459 34.842)",
    fill: "#1c5866"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9397",
    "data-name": "Rectangle 9397",
    width: 38.494,
    height: 3.915,
    transform: "translate(24.459 51.805)",
    fill: "#1c5866"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9398",
    "data-name": "Rectangle 9398",
    width: 38.494,
    height: 3.915,
    transform: "translate(24.459 67.899)",
    fill: "#1c5866"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24030",
    "data-name": "Path 24030",
    d: "M12.524,0A12.523,12.523,0,1,0,25.047,12.524,12.523,12.523,0,0,0,12.524,0m0,18.9A6.374,6.374,0,1,1,18.9,12.524,6.374,6.374,0,0,1,12.524,18.9",
    transform: "translate(62.953 77.448)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeyImageCard);
export default __webpack_public_path__ + "static/media/ley_image_card.5acabae05de920da8d39fc59474f0ec3.svg";
export { ForwardRef as ReactComponent };